import styled from '@emotion/styled';

import { NavigationButtons as BaseNavigation } from 'components/checkout';

export const Title = styled.h1`
  font-size: 2.6rem;
  font-weight: normal;
  margin: 1rem 1rem 1.43rem;
`;

export const NavigationButtons = styled(BaseNavigation)`
  margin: 2.3rem 1rem 0;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e5e5;
`;

export const SubtotalBlock = styled.div`
  font-weight: bold;
  padding: 0.8rem 1.08rem;
  background: #e0e0e0;
  text-align: right;

  span:first-of-type {
    display: inline-block;
    width: 83%;
  }

  span:last-child {
    display: inline-block;
    width: 17%;
  }
`;

export const TotalBlock = styled(SubtotalBlock)`
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textLight};
`;
